import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MailService {
  constructor(private http: HttpClient) {
   }


  sendMail(message){
    return this.http.post('https://focuscovid.azurewebsites.net/api/Lead', JSON.stringify(message));

}

}
